import axios from '@/axios'
import Vue from 'vue'

const state = {
    visitrecorder: [],
};

const actions = {
    fetchVisitrecorder({ commit }) {
        return axios.get('visitrecorder')
            .then(r => commit('SET_VISITRECORDER', r.data));
    }
};

const mutations = {
    SET_VISITRECORDER(state, data) {
        Vue.set(state, 'visitrecorder', data);
    }
};

export default {
    state,
    actions,
    mutations
}